import { IFetchEntityFailureActionPayload } from 'app/projects/entity/src/lib/interfaces/fetch-entity-failure-payload.interface';

export class FetchUserFailure {
    static readonly type = '[User] FetchUserFailure';

    constructor(public payload: IFetchEntityFailureActionPayload) {}
}
